/**
 * Knowledge points that can be highlighted throughout the lessons
 */
export const knowledgePoints = {
  versionImportance: {
    title: "Know your tool's version",
    content: `It's important for a software engineer to know the versions of tools installed for several critical reasons:

**Compatibility and Stability**
Different versions of tools and libraries may introduce breaking changes or compatibility issues. Knowing exact versions ensures the developed code works consistently across development, testing, and production environments.

**Reproducibility and Consistency**
Specifying exact versions makes it easier to reproduce builds and resolve bugs. Avoids the "works on my machine" problem, ensuring all team members have a consistent development environment.

**Security**
Older versions of software often contain vulnerabilities that have been fixed in newer releases. Being aware of versioning helps engineers ensure their tools are patched and secure.

**Dependency Management**
Many tools have dependencies, and mismatches between dependency versions can cause integration problems. Keeping track of versions helps manage complex dependency trees effectively.

**Easier Debugging and Troubleshooting**
Version discrepancies can lead to subtle and difficult-to-identify bugs. Knowing the tool versions aids quicker debugging by allowing engineers to check release notes or known issues specific to a version.

**Performance Optimization**
Newer tool versions might offer performance improvements, optimizations, or bug fixes. Conversely, sometimes newer versions might introduce performance regressions, and knowing the version helps engineers decide when to upgrade or downgrade.

**Compliance and Auditing**
Certain industries require precise software versioning for audit and compliance reasons. Accurate version tracking demonstrates due diligence and adherence to best practices.`
  },
  
  // Add more knowledge points here as needed
  gitBranching: {
    title: "Understanding Git Branching Strategy",
    content: `Git branching strategies are essential for effective collaboration and code management in software development.`
  },

  infrastructure: {
    title: "Infrastructure as Code Benefits",
    content: `Infrastructure as Code (IaC) provides numerous benefits for modern software development.`
  }
}; 